import { assign, object } from 'superstruct';
import { IdObject, isoDateTimeWithCoercions, parsableInteger } from '@arc/shared/util-superstruct';
import { BaseFilter } from './base-filter.dto';
export const ViewFilterDto = assign(BaseFilter, object({
  id: parsableInteger(),
  createdAt: isoDateTimeWithCoercions(),
  updatedAt: isoDateTimeWithCoercions(),
  createdBy: IdObject
}));